import {useSelector} from 'react-redux';

export default () =>
	useSelector(({activityLog}) => {
		const {page, totalEntityCount, pageSize} = activityLog;
		return {page, totalEntityCount, pageSize};
	});
